import { styled } from "styled-components";

import { OpenInfo } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components/foundations";

export const StyledOpenInfoIcon = styled(OpenInfo)`
    visibility: var(--more-details-icon-visibility, hidden);
    flex-shrink: 0;
    background-color: ${colorsPalettes.blue[400]};
    border-radius: 4px;
    padding: 2px;
`;

export const TableWrapper = styled.div`
    --more-details-icon-display: none;
    --more-details-icon-visibility: hidden;

    & .ant-table-cell-row-hover {
        --more-details-icon-display: block;
        --more-details-icon-visibility: visible;
    }
`;

type MoreDetailsIconWrapperProps = {
    $disabled?: boolean;
};

export const MoreDetailsIconWrapper = styled.span<MoreDetailsIconWrapperProps>`
    display: var(--more-details-icon-display);
    width: 28px;
    height: 28px;
    border-radius: 4px;
    background-color: ${({ $disabled }) =>
        $disabled ? colorsPalettes.carbon[200] : colorsPalettes.blue[400]};
    opacity: ${({ $disabled }) => ($disabled ? 0.65 : 1)};
    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "inherit")};
    pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
`;

export const StyledMoreDetailsIcon = styled(OpenInfo)`
    margin: 2px 0px 0px 1px;
`;

export const ClickableRowsTableBox = styled(Box)`
    table tbody tr {
        cursor: pointer;
    }
`;
